import validate from 'validate.js'

const constraints = {
  lessonId: {
    presence: true
  },
  startDate: {
    presence: true
  },
  ignoreEducatorUnavailability: {
    presence: false
  }
}

export default (data) => {
  return validate(data, constraints)
}
